import { useState } from "react";
import { toast } from "sonner";
import { Storefront } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { KIOSK_TOKEN_KEY, setDeviceMode } from "@/lib/kioskApi";
import { KIOSK_PARKED_KEY } from "@/components/kiosk/KioskExit";

const errText = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";

// Shown inside Admin/POS when this device was opened from the customer kiosk via the hidden logo hold.
export function KioskReturnBanner() {
  const [busy, setBusy] = useState(false);
  const deviceId = localStorage.getItem(KIOSK_PARKED_KEY);
  if (!deviceId) return null;
  const back = async () => {
    setBusy(true);
    try {
      const r = await api.post("/devices/resume-kiosk", { device_id: deviceId });
      localStorage.setItem(KIOSK_TOKEN_KEY, r.data.kiosk_token);
      localStorage.removeItem("mm_token");
      localStorage.removeItem(KIOSK_PARKED_KEY);
      setDeviceMode("kiosk");
      window.location.href = "/kiosk";
    } catch (e) {
      toast.error(errText(e));
      if (e?.response?.status === 409 || e?.response?.status === 404) localStorage.removeItem(KIOSK_PARKED_KEY);
      setBusy(false);
    }
  };
  return (
    <div className="sticky top-0 z-40 flex items-center justify-between gap-3 px-4 py-2 bg-[#0f2a3d] text-white text-sm" data-testid="kiosk-return-banner">
      <span>This is the customer kiosk device — opened for staff use.</span>
      <button className="h-9 px-4 rounded-full bg-[#e2572b] font-semibold inline-flex items-center gap-2 disabled:opacity-50 active:scale-95 transition-transform"
        disabled={busy} onClick={back} data-testid="kiosk-return-button"><Storefront size={16} weight="fill" /> {busy ? "Returning…" : "Return to Kiosk"}</button>
    </div>
  );
}
